module.exports = __webpack_public_path__ + "static/media/loading-avatar-animado.8f392fc6.svg";